import { render, staticRenderFns } from "./our-partners.vue?vue&type=template&id=ae2d1b0e&scoped=true&"
import script from "./our-partners.vue?vue&type=script&lang=js&"
export * from "./our-partners.vue?vue&type=script&lang=js&"
import style0 from "./our-partners.vue?vue&type=style&index=0&id=ae2d1b0e&scoped=true&lang=css&"
import style1 from "./our-partners.vue?vue&type=style&index=1&id=ae2d1b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2d1b0e",
  null
  
)

export default component.exports